import { QueryKey } from "@tanstack/react-query";

export const leadSourceQueryKeys = {
  all: () => ['leadSource'] as QueryKey,
  list: (filters: Readonly<{ [k: string]: any }>) => [...leadSourceQueryKeys.all(), { filters }] as QueryKey,
  details: (leadSourceId: number) => [...leadSourceQueryKeys.all(), leadSourceId] as QueryKey,
};
